import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function DisplaySearch({
  selectedRarities,
  handleRarityChange,
  sortOption,
  setSortOption,
  groupByObtain,
  setGroupByObtain,
  searchTerm,
  setSearchTerm,
}) {
  const [username, setUsername] = useState("");
  const timeoutRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const search = params.get("search") || "";
    setSearchTerm(search);
  }, [location.search, setSearchTerm]);

  const updateURL = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    const params = new URLSearchParams(location.search);
    if (searchTerm) {
      params.set("search", searchTerm);
    } else {
      params.delete("search");
    }
    navigate(`?${params.toString()}`, { replace: true });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      updateURL();
    }, 3000);
  };

  const handleClear = () => {
    setSearchTerm("");
    const params = new URLSearchParams(location.search);
    params.delete("search");
    navigate(`?${params.toString()}`, { replace: true });
  };

  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  const rarityOrder = [
    "common",
    "rare",
    "epic",
    "legendary",
    "limited",
    "exotic",
    "partner",
  ];

  const sortOptions = groupByObtain
    ? ["default", ...(username ? ["owned", "unowned"] : [])]
    : [
        "rarity",
        "alphabetical",
        "Number ID",
        ...(username ? ["owned", "unowned"] : []),
      ];

  const rarityImages = {
    common: "singles-c",
    rare: "singles-r",
    limited: "singles-lm",
    epic: "singles-e",
    legendary: "singles-l",
    exotic: "singles-ex",
    partner: "singles-p",
  };

  return (
    <div className="search_container">
      <div
        className="cosmetic_display_search mobile-only"
        style={{ position: "relative" }}
      >
        <input
          name="keyword"
          type="text"
          placeholder="Search..."
          className="search-input"
          onChange={handleChange}
          onBlur={updateURL}
          value={searchTerm}
        />
        {searchTerm && (
          <button
            onClick={handleClear}
            className="search-clear-button"
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              fontSize: "16px",
              color: "#aaa",
              cursor: "pointer",
              padding: 0,
              zIndex: 2,
            }}
            aria-label="x"
          >
            ✕
          </button>
        )}
      </div>

      <div className="cosmetic_display_search_wrapper">
        <div className="horizontal-center">
          <div
            className="cosmetic_display_search pc-only"
            style={{ position: "relative" }}
          >
            <input
              name="keyword"
              type="text"
              placeholder="Search..."
              className="search-input"
              onChange={handleChange}
              onBlur={updateURL}
              value={searchTerm}
            />
            {searchTerm && (
              <button
                onClick={handleClear}
                className="search-clear-button"
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  fontSize: "16px",
                  color: "#aaa",
                  cursor: "pointer",
                  padding: 0,
                  zIndex: 2,
                }}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>

          <div className="checkbox-horizontal">
            <div className="select-checkbox">
              <div className="white-button-header">
                <button
                  style={{ fontFamily: "Minecraft Seven", padding: 0 }}
                  className="white-button"
                >
                  <img
                    src="https://app.zeqa.net/image/toggles/filters.webp"
                    alt="Filters"
                    style={{ maxWidth: "40px", maxHeight: "34px" }}
                  />
                </button>
                <div className="toggle-dropdown">
                  {rarityOrder.map((rarity) => (
                    <div key={rarity} className="checkbox-container">
                      <input
                        type="checkbox"
                        id={`checkbox-${rarity}`}
                        value={rarity}
                        onChange={handleRarityChange}
                        checked={selectedRarities.includes(rarity)}
                      />
                      <label
                        htmlFor={`checkbox-${rarity}`}
                        className="checkbox"
                      >
                        <div
                          className={`unicode-sprite ${rarityImages[rarity]}`}
                        />
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="select-checkbox">
              <div className="white-button-header">
                <select
                  id="sort-dropdown"
                  className="white-button"
                  onChange={handleSortChange}
                  value={sortOption}
                  style={{
                    fontFamily: "Minecraft Seven",
                    padding: "8.5px",
                    cursor: "pointer",
                  }}
                >
                  {sortOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt.charAt(0).toUpperCase() + opt.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="select-checkbox">
              <div className="white-button-header">
                <button
                  style={{ fontFamily: "Minecraft Seven", padding: 0 }}
                  className="white-button"
                  onClick={() => setGroupByObtain(!groupByObtain)}
                >
                  <img
                    src="https://app.zeqa.net/image/toggles/group.webp"
                    alt="Group by Obtain"
                    style={{ maxWidth: "40px", maxHeight: "34px" }}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
